import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/city/city-default-mobile.jpg")